










































































































































































































import Component from 'vue-class-component';
import Vue from 'vue';
import {generateFile, isEmpty, logger} from "../../plagins/utils";
import {Kt, Record} from '../interfaces';
import {State, Styles} from "../store";
import {trans} from "../../plagins/translate";

declare global {
  interface Window {
    json_context: any;
  }
}

const QUOTE = "%quote%"
@Component({
  components: {}
})
export default class Home extends Vue {
  is_show_details_by_default = false;

  state: State | any = {};

  search = '';
  active_dist = 0;
  csrf_token: string = (document.querySelector('meta[name="csrf_token"]') as HTMLMetaElement).content

  styles: Styles | any = {};

  searchOn() {
    this.$store.commit('apply_filter');
    this.clearFocus();
  }

  cssFoundItem(item:Record){
    return 'px-3 '+ item.bib.toString()===this.state.search.toString()?this.styles.background_color_accent_2 :''
  }

  computed() {
    const styles = this.styles
    return {
      background_color_accent_2() {
        return styles.background_color_accent_2;
      },

    }
  }

  onClickDownloadDiploma(event: MouseEvent, item: Record) {
    event.stopPropagation()

    const columns = this.state.settings.columns

    let data: { [id: string]: any } = {}
    Object.assign(data, item)

    for (let kt of data.kts) {
      data[columns[kt.id].name] = kt.value
    }
    delete data.kts
    delete data.last_kt


    data.first_name = data.name
    const template_id = this.state.remote_data.certificate_templates_dict[data.dist]
    console.log(data)
    generateFile('/certificates/generate-certificates',
        JSON.stringify([data]),
        'application/pdf',
        // `${this.state.remote_data.event}-${dist}-${item.name}.pdf`,
        `GeneratedCertificates.pdf`,
        [
          {
            name: "csrfmiddlewaretoken",
            value: this.csrf_token
          },
          {
            name: "template",
            value: template_id
          },
        ])
  }

  clearFocus() {
    setTimeout(() => {
      (document.activeElement as HTMLElement).blur();
    }, 1);

  }

  startSearch() {
    if (!isEmpty(this.search)) {
      this.$store.commit('set_search', this.search);
    } else {
      this.$store.commit('set_search', '')
    }
    this.$store.commit('apply_filter');
    this.clearFocus();

  }

  changeSearch(value: string) {
    if (!isEmpty(value)) {
      this.$store.commit('set_search', value)
    } else {
      this.$store.commit('set_search', '')
    }
  }

  clearSearch(value: string) {
    this.$store.commit('set_search', '');
    this.$store.commit('apply_filter');
    this.clearFocus();
  }

  pageInput(page: number) {
    this.$store.commit('set_paginator', {
      offset: this.state.paginator.limit * (page - 1),
      limit: this.state.paginator.limit
    });
    this.$store.commit('subscribe_on_update_data');
  }

  trans(s: string): string {
    return trans(s);
  }

  selectItem(record: Record, index: number) {
    let selected = record.selected;
    this.$store.commit('clean_records_selected');
    record.selected = !selected;
  }

  selectDistance(dist: string) {
    this.$store.commit('set_field_dist', dist);
    this.$store.commit('set_paginator', {
      offset: 0,
      limit: this.state.paginator.limit
    });
    this.$store.commit('set_pagination', {
      page: 1,
      length: this.state.pagination.length
    });
    this.$store.commit('subscribe_on_update_data');
  }


  getKtTitle(kt: Kt) {
    return this.state.settings.columns[kt.id].title;
  }


  mounted(): void {

  }

  isEmpty(value: any): boolean {
    return isEmpty(value);
  }


  created(): void {
    this.state = this.$store.state;
    this.styles = this.state.remote_data.styles;
  }

  destroyed(): void {

  }
}
